const allowFunctionalCookiesKey = 'allowFunctionalCookies'
class StorageHelperClass {
    private inMemoryStore: { [key: string]: string|null } = {}
    public get allowFunctionalCookies(): boolean {
        return localStorage.getItem(allowFunctionalCookiesKey) === 'true'
    }
    public set allowFunctionalCookies(newVal: boolean) {
        if(newVal) {
            localStorage.setItem(allowFunctionalCookiesKey, 'true')
        } else {
            localStorage.clear()
        }
    }

    public getItem(key: string): string|null {
        if(this.allowFunctionalCookies) {
            return localStorage.getItem(key)
        } else {
            return this.inMemoryStore[key]
        }        
    }
    public setItem(key: string, val: string) {
        if(this.allowFunctionalCookies) {
            localStorage.setItem(key, val)
        } else {
            this.inMemoryStore[key] = val;
        }
    }
}

const StorageHelper = new StorageHelperClass()
export default StorageHelper